import React, { createContext, useContext, useState, useEffect, useRef, useMemo, useCallback } from 'react';
import api from '../services/api';
import { useAuth } from './auth';

const WarningContext = createContext({});

export const WarningProvider = ({ children }) => {
  const [warnings, setWarnings] = useState([]);
  const { id_empresa } = useAuth();

  const fetchedId = useRef(null);

  const updateWarning = useCallback(async (warning) => {
     const response = await api.patch(`/avisos/marcar-lido/${warning.Id}/${id_empresa}`);
    setWarnings((state) =>
      state.map((e) => (e.Id === response.data.Id ? response.data : e))
    );
  }, [id_empresa]);

  const refetchWarnings = useCallback(() => {
    if (!id_empresa) return;

    api
      .get(`/avisos/listar/${id_empresa}`)
      .then((res) => {
        setWarnings(res.data);
      })
      .catch((error) => {
        console.error("Erro ao buscar avisos:", error);
        fetchedId.current = null;
      })
  }, [id_empresa]);

  useEffect(() => {
    if (!id_empresa) {
      setWarnings([]);
      fetchedId.current = null;
      return;
    }

    if (fetchedId.current === id_empresa) {
      return;
    }

    fetchedId.current = id_empresa;
    refetchWarnings();

  }, [id_empresa, refetchWarnings]);

  const unreadCount = useMemo(() => {
    return warnings.filter(w => w.Lido === 0).length;
  }, [warnings]);

  return (
    <WarningContext.Provider value={{
      warnings,
      unreadCount,
      updateWarning,
      refetchWarnings
    }}>
      {children}
    </WarningContext.Provider>
  );
};

export function useWarnings() {
  const context = useContext(WarningContext);

  if (!context || Object.keys(context).length === 0) {
    throw new Error('useWarnings must be used within a WarningProvider');
  }
  return context;
}
